export default function initMenu() {
  const headerElement = document.body;
  if (!headerElement) {
    return;
  }

  let lastScrollTop = window.scrollY;

  function updateHeader() {
    const scrollTop = window.scrollY;
    const isDesktop = window.innerWidth > 768;
    const isFixed =
      (isDesktop && scrollTop > 1) || (!isDesktop && scrollTop > 1);

    if (
      isFixed &&
      scrollTop < lastScrollTop &&
      scrollTop > lastScrollTop - 60
    ) {
      return;
    }

    function toggleClasses() {
      if (isFixed && scrollTop > lastScrollTop) {
        headerElement.classList.add("scrolled-down");
      }
      if ((isFixed && scrollTop < lastScrollTop - 60) || !isFixed) {
        headerElement.classList.remove("scrolled-down");
      }

      headerElement.classList.toggle("scrolled", isFixed);
    }

    toggleClasses();
    lastScrollTop = scrollTop;
  }
  window.addEventListener(
    "scroll",
    (e) => {
      updateHeader();
    },
    false
  );

  updateHeader();

  window.addEventListener("scroll", function () {
    const scrollPosition = window.scrollY; // Get current vertical scroll position
    const threshold = 116; // Set the threshold for adding/removing the class

    if (scrollPosition >= threshold) {
      document.body.classList.add("navbar-styled"); // Add class if scrollPosition is equal or greater than 116px
    } else {
      document.body.classList.remove("navbar-styled"); // Remove class if scrolled to the top
    }
  });
}
